/*
 * Selman Gold – small UI helpers
 *   [data-sg-toggle][aria-controls]  button that shows/hides the element with that id; toggles class is-active,
 *                                    swaps the text of [data-sg-toggle-label] between data-label-open/-closed
 *   select[data-sg-sort]             reloads the collection with ?sort_by=<value>
 *   [data-auto-submit]               submits its form on change (cart quantities)
 *   [data-cookie-settings]           opens Shopify's cookie preferences (privacy banner), if enabled
 *   <sg-choice>                      single-choice chip group: [data-choice="value"] buttons write their value
 *                                    into [data-choice-input] (hidden form field), pressed chip gets is-active
 */
(function () {
  'use strict';
  if (window.SGUI) return; // several sections may include this file
  window.SGUI = true;

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cookie-settings]');
    if (!link) return;
    e.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sg-toggle]');
    if (!btn) return;
    var target = document.getElementById(btn.getAttribute('aria-controls'));
    if (!target) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.classList.toggle('is-active', open);
    target.hidden = !open;
    var label = btn.querySelector('[data-sg-toggle-label]');
    var text = btn.getAttribute(open ? 'data-label-open' : 'data-label-closed');
    if (label && text) label.textContent = text;
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('select[data-sg-sort]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  document.addEventListener('change', function (e) {
    var field = e.target.closest('[data-auto-submit]');
    if (field && field.form) field.form.submit();
  });

  if (!customElements.get('sg-choice')) {
    customElements.define('sg-choice', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          var chip = e.target.closest('[data-choice]');
          if (!chip) return;
          this.querySelectorAll('[data-choice]').forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var input = this.querySelector('[data-choice-input]');
          if (input) input.value = chip.getAttribute('data-choice');
        });
      }
    });
  }
})();
